export const theme = {
  palette: {
    primary: "#0ABAB5",
    secondary: "#FFAB00",
    text: "rgba(0, 0, 0, 0.85)",
    secondaryText: '#7f8fa4',
    link: '#1890ff',
    pending: "#00b2ff",
    success: "#52c41a",
    warning: "#faad14",
    error: "#ff4d4f",
    menuBg: '#fff',
    menuText: 'rgba(0, 0, 0, 0.85)',
    menuActiveText: '#5d487a',
    border: '#F5F0F0',
    
    dropdownShadow: "lightgrey",
    sliderBg: "#5aceff",
    sliderContentBg: "white",
    mainColor: "#18a0fb",
    darkColor: "#263238",
    customColor1: "#000",
    lightThemeText: "black",
    tableHeaderBg: '#fafafa'
  },
};